export const profileUpdater = payload =>({
    type: "UPDATE_PROFILE",
    payload,
})